import React, { useState , useEffect} from 'react';
import PropTypes from 'prop-types';
import engImg from '../../../assets/images/english.png';
import jpnImg from '../../../assets/images/japanese.png';
import { useTranslation } from 'react-i18next';

const CustomTranslate=(props)=>{

    const { i18n } = useTranslation();
    let langSel = localStorage.getItem('i18nextLng') || 'en';
    const [displayDiv, changeDisplay] = useState('none');
    const [displayLanguage, changeDisplayLanguage] = useState(langSel);
    const selImgae = langSel === 'en' ? engImg : jpnImg;
    const [imageUrl, changeImageURL] = useState(selImgae);

    useEffect(() => {
        let langSelected = localStorage.getItem('i18nextLng') || 'en';
        let imgSel = langSelected === 'en' ? engImg : jpnImg;
        changeImageURL(imgSel);
      }, [])

    const changeLanguage = lng => {
        if(lng === 'jp'){
            changeDisplayLanguage(lng);
            changeImageURL(jpnImg);
        }else{
            changeDisplayLanguage(lng);
            changeImageURL(engImg);
        }
        i18n.changeLanguage(lng);
        changeDisplay('none');
      };
    
    const selectLanguage= () =>{
        changeDisplay('block');
    }

    return(
        <div className={`translate-area ${props.className}`}>
            <nav tabIndex="0">
                <div className="lang-menu">
                    <div className="selected-lang" onClick={() => selectLanguage()}>
                        <img src={imageUrl} alt="languageImage" />
                        <label>{displayLanguage === 'jp' ? "JP" : "EN"}</label>
                    </div>
                    <ul style={{display:`${displayDiv}`, zIndex: '1'}}>
                        <li tabIndex="0">
                            <div className="jp" onClick={() => changeLanguage('jp')}>{"JP"}</div>
                        </li>
                        <li tabIndex="0">
                            <div className="en" onClick={() => changeLanguage('en')}>{"EN"}</div>
                        </li>
                    </ul>           
                </div>
            </nav>
        </div>
    )
}

CustomTranslate.propTypes = {
    className: PropTypes.string,
    t:PropTypes.any,
  };
 

export default CustomTranslate;